<template>
  <div class="w-full mx-auto overflow-hidden">
    <div class="flex flex-col max-w-6xl w-full mx-auto overflow-hidden px-4">
      <h1 class="text-2xl text-gray-900 mb-8 border-b self-center">{{ $t('contact.title') }}</h1>
    </div>

    <div ref="consult" class="flex flex-col max-w-6xl w-full mx-auto overflow-hidden px-4 my-16">

      <div class="text-gray-800 text-sm">
        <div class="flex flex-wrap">

          <div class="p-3 xl:w-1/3 lg:w-1/3 md:w-1/3 sm:w-full xs:w-full group flex flex-wrap">
            <h2 class="text-2xl text-gray-900 mb-4 border-b self-start">Contact</h2>
            <div class="text-gray-800 text-sm" v-html="$t('contact.address')">
            </div>
          </div>

          <div class="p-3 xl:w-1/3 lg:w-1/3 md:w-1/3 sm:w-full xs:w-full group flex flex-wrap">
            <div class="w-1/3">
              <img src="/assets/img/dda/Filip_Fagaraseanu.jpg" itemprop="thumbnail">
            </div>
            <div class="w-1/2 m-auto">
              <h4 class="font-bold text-normal mt-2"> Filip Făgărășeanu <br/></h4>
              <p> Shop consultant <br/></p>
              <p class="mt-1"> <a href="tel:+40736607042">+40 736 607 042</a>, filip.fagaraseanu@artmark.ro </p>
            </div>
          </div>

          <div class="p-3 xl:w-1/3 lg:w-1/3 md:w-1/3 sm:w-full xs:w-full group flex flex-wrap">
            <div class="w-1/3">
              <img src="/assets/img/dda/Andreea_Plugariu.jpg" itemprop="thumbnail">
            </div>
            <div class="w-1/2 m-auto">
              <h4 class="font-bold text-normal mt-2"> Andreea Plugariu <br/></h4>
              <p> Gallery Shop Manager <br/></p>
              <p class="mt-1"> <a href="tel:+40757026455">+40 757 026 455</a>, andreea.plugariu@artmark.ro </p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div ref="contact" class="flex flex-col max-w-6xl w-full mx-auto overflow-hidden px-4 my-16">
      <img src="/assets/img/harta-site_DDA.png" class="img-fluid mt-1"/>
<!--      TO DO!!!! -->
<!--      <img v-if="locale() == 'ro'" src="/assets/img/harta-site_DDA.png" class="img-fluid mt-1"/>-->
<!--      <img v-else src="assets/img/harta-site_new_en.png" class="img-fluid mt-1"/>-->
      <button type="button" name="button" @click="showMap()"
              class="btn action_box w-100 action_box_full_width_mobile rounded-0 mb-5 showMAp">MAP
      </button>
      <iframe id="harta" v-if="toggleMap" style="margin:0 auto;" width="100%" height="480"
              frameborder="0"
              scrolling="no" marginheight="0" marginwidth="0"
              src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=C.A+Rosseti+nr.5&amp;aq=&amp;sll=37.0625,-95.677068&amp;sspn=39.371738,86.572266&amp;ie=UTF8&amp;hq=C.A+Rosetti+nr.5&amp;hnear=&amp;radius=15000&amp;t=m&amp;cid=5563000609928991653&amp;ll=44.444841,26.095662&amp;spn=0.014706,0.027466&amp;z=15&amp;iwloc=A&amp;output=embed"></iframe>
    </div>
  </div>
</template>

<style scoped>

.addToCartDisabled {
  background: #48bb78 !important;
  cursor: pointer;
  display: block;
}

.carousel-cell {
  width: 100%;
  height: auto;
  position: absolute;
  left: 0%;
}

.carousel-cell-image {
  width: 100%;
  display: block;
}

.caption-slider-landing {
  background: white;
  opacity: 0.8;
  width: 100% !important;
  position: absolute;
  bottom: 0 !important;
}
</style>

<script>
import Layout from '@/Shared/Layout'
import Dropdown from '@/Shared/Dropdown'
import Flickity from 'vue-flickity'
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: 'Acasă',
      meta: [
        {
          name: 'robots',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {
          name: 'googlebot',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {name: 'title', content: 'Dependent de Arta - Magazinul tau de Artă!'},
        {
          name: 'description',
          content: 'Magazinul tău de artă: pcituri, sculpturi, gravuri, bijuterii, ceasuri, arta decorativa si multe altele. Viziteaza-na sau cumpara online acum!'
        },
        {name: 'keywords', content: 'dependent de arta'},
        // Facebook
        {name: 'og:title', property: 'og:title', content: 'Dependent de Artă - Cel mai mare magazin de artă din România'},
        {
          name: 'og:description',
          property: 'og:description',
          content: 'Art Boutique Dependent de Artă este serviciul care vă pune la dispoziție opere de artă pentru achiziția imediată și directă'
        },
        {name: 'og:image', property: 'og:image', content: 'Placeholder Image Link'},
        {name: 'og:url', property: 'og:url', content: window.location.href},
        {name: 'og:type', property: 'og:type', content: 'website'},
      ]
    }
  },
  layout: Layout,
  components: {
    Layout,
    Flickity,
    Dropdown
  },
  props: {
    featured: Array,
    slide: Object,
    categories: Array,
    anchor: String,
  },
  data() {
    return {
      flickityOptions: {
        lazyLoad: true,
        imagesLoaded: false,
        cellAlign: 'center',
        adaptiveHeight: true,
        contain: true,
        autoPlay: true,
        wrapAround: true,
        fade: true,
        pageDots: false,
        prevNextButtons: false,
      },
      toggleMap: false
    }
  },
  methods: {
    inArray(needle) {
      var haystack = Object.keys(this.$page.cart.items);
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    locale() {
      return window.location.pathname.split('/')[1];
    },
    addToCart(id) {
      let locale = window.location.pathname.split('/')[1];
      axios({
        method: "post",
        url: '/' + locale + '/cart/add/' + id
      }).then((response) => {
        if (response.data.status == 'success') {
          let carts = document.querySelectorAll('sup.cart_quantity');
          for (let i = 0, len = carts.length; i < len; ++i) {
            let cart = carts[i];
            cart.innerHTML = response.data.quantity;
          }
          if (locale != 'ro') {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/en/cart' style='background: #48bb78;display: block;' class=\"btn-gray a10-btn-padding addToCartDisabled\">Product added!<br/>Go to your cart!</a>";
          } else {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/ro/cart' style='background: #48bb78;display: block' class=\"btn-gray a10-btn-padding addToCartDisabled\">Produs adăugat!<br/>Vezi coșul!</a>";
          }
        } else {
          this.$iziToast.show({
            message: response.data.message,
            color: 'red',
            position: null,
            target: "#iziToast-wrapper_cart_" + id,
            progressBar: false,
            timeout: 500000,
            displayMode: 'replace'//once
          });
        }
      });
    },
    scrollToTarget(target) {
      const navOffset = 100;
      const targetPosition = target.getBoundingClientRect().top;
      const offsetPosition = targetPosition - navOffset + 625; //625 = magic number, satans own cnp


      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },
    currentPage() {
      return window.location.href
    },
    copyToClipboard(lot) {
      return window.navigator.clipboard.writeText(this.route('shop.lot.view', lot.slug));
    },
    showMap() {
      this.toggleMap = this.toggleMap ? false : true;
    }
  },
  mounted() {
    if (this.anchor) {
      this.scrollToTarget(this.$refs[this.anchor])
      history.replaceState('', 'Acasă', '/');
    }
  }
}
</script>
